import debug from "debug";
import _ from "lodash";

const errLog = debug("nqm-core-utils:build-data-key");

/*
  * Extract a dictionary of values from params corresponding to the given array of field paths,
  * where paths use the dot notation, e.g. address.postcode.
  */
export const buildDataKey = function(fieldPaths, params, failIfIncomplete) {
  const keys = {};
  _.forEach(fieldPaths, function(f) {
    // Get the field path.
    const key = f.asc || f.desc;
    const val = _.get(params, key);
    if (val === undefined) {
      errLog("no key data for field '%s' in %j", key, params);
      if (failIfIncomplete) {
        throw new Error(`buildDataKey - incomplete primary key: no data for '${key}' in ${JSON.stringify(params)}`);
      }
    } else {
      keys[key] = val;
    }
  });

  return keys;
};

/**
 * Promise version of the above
 */
export const buildDataKeyEx = function(fieldPaths, params, failIfIncomplete) {
  try {
    return Promise.resolve(buildDataKey(fieldPaths, params, failIfIncomplete));
  } catch (err) {
    return Promise.reject(err);
  }
};



// WEBPACK FOOTER //
// ./src/build-data-key.js